export enum EElectronicInvoiceType {
  COMPANY = 'company',
  NATURAL_PERSON = 'natural_person',
}
